module.exports = __webpack_public_path__ + "static/media/game(26).d3a9dc0b.PNG";